import { useMemo } from 'react';

import { useRemoteSettings } from 'providers/RemoteSettingsProvider';
import type { IPreset, IRemotePresetShelf } from 'services/presets/types';

// Older remote configs predate the `type` discriminator. Treat missing `type` as 'actions'
// so legacy entries keep working alongside new webhook presets.
function normalizePreset(preset: IPreset): IPreset {
  if ((preset as { type?: IPreset['type'] }).type) return preset;
  return { ...(preset as IPreset), type: 'actions' } as IPreset;
}

export function useRemotePresetShelves(): IRemotePresetShelf[] {
  const { batch_editor_miniapp } = useRemoteSettings();

  return useMemo(() => {
    const shelves = batch_editor_miniapp?.preset_shelves;
    if (!Array.isArray(shelves)) return [];
    return shelves.map(shelf => ({
      ...shelf,
      presets: Array.isArray(shelf.presets) ? shelf.presets.map(normalizePreset) : [],
    }));
  }, [batch_editor_miniapp?.preset_shelves]);
}
